import React, { useEffect } from 'react';
import VerificationInput from 'react-verification-input';
import axios from 'axios';
import styles from './styles.scss';
import { WIX_INSTANCE_PARAMS } from '../../actions/component_actions';

const CODE_LENGTH = 5;

export const InputVerificationCode = ({ saved_code_key, onSubmit, email, settings }) => {
  const [value, setValue] = React.useState('');
  const [error, setError] = React.useState('');

  const onChange = async (e) => {
    setError('');
    const val = e
      .split('·')
      .filter((p) => p)
      .join();
    try {
      setValue(e);
      if (val.length === CODE_LENGTH) {
        const { data } = await axios.post(
          `${process.env.EVENTVIEWER_SERVER}/auth/code-validate${WIX_INSTANCE_PARAMS}`,
          { email, verification: { code: val, id: saved_code_key } },
          { withCredentials: true }
        );
        onSubmit(data);
      }
    } catch (err) {
      console.error(err);
      setError(`Code is invalid. Try again!`);
    }
  };

  useEffect(() => {
    async function sendCode() {
      await axios.post(
        `${process.env.EVENTVIEWER_SERVER}/auth/code-request${WIX_INSTANCE_PARAMS}`,
        { key: saved_code_key, email },
        { withCredentials: true }
      );
    }
    sendCode();
  }, []);

  return (
    <>
      <div className={styles.text}>
        <div className="fast-checkout-verification-text">
          {settings.get('emailVerificationText')} <div>{email}</div>
        </div>
      </div>
      <VerificationInput
        removeDefaultStyles
        classNames={{
          container: 'pin-verify-container',
          character: 'pin-verify-character',
          characterInactive: 'pin-verify-character--inactive',
          characterSelected: 'pin-verify-character--selected',
        }}
        length={CODE_LENGTH}
        onChange={onChange}
        value={value}
      />
      {error && <div className={styles.error}>{error}</div>}
    </>
  );
};
